import '../Home/Home.css';
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import React, { Component } from "react";
import withNavigateHook from '../../myRoutes';
import axios from 'axios';
import Select from 'react-select';
//import { parse } from 'next/dist/build/swc/generated-native';

class Casereports extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            startdate: "",// new Date(),
            enddate: "", // new Date(),
            selectedDate: new Date(),
            userRole: "",
            firstname: "",
            lastname: "",
            db: "",
            groupCases: [],
            caseid: "",
            groupMembers: [],
            globalGroupMembers: [],
            casesStatuses: [],
            casename: "",
            groupMembersCount: 0,
            paidmembersCount: 0,
            notPaidmembersCount: 0,
            paidPercentage: 0,
            sortedValues: []

        }
    }
    lGroupCases = [];
    //innerGroupCases = [];
    lCaseId = 0;
    casecategory = "";
    casestartdate = ";"
    caseamount = "";
    strImage = "";
    strTag = "";
    str_ = '';
    strcolor = 'darkorange';
    allGroupMembersCount = 0;

    componentDidMount = () => {
        this.setState({
            db: this.props.location.state.db, firstname: this.props.location.state.firstname,
            email: this.props.location.state.email, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
        });
        this.loadGroupCases();
        this.getAllCaseStatuses();
        //this.loadPendingPayCases();
        this.loadGroupAllMembers();
    }

    getGroupCaseStats = (caseid) => {
        let paidCount = [];
        let sortedArray = [];
        let notPaidCount = 0;
        let percentage = 0;

        for (let b = 0; b < this.state.casesStatuses.length; b++) {
            if (caseid === this.state.casesStatuses[b].caseid) {
                paidCount.push(this.state.casesStatuses[b].memberId)
            }
        }

        this.setState({ paidmembersCount: paidCount.length })
        notPaidCount = parseFloat(this.state.globalGroupMembers.length) - parseFloat(paidCount.length)
        percentage = (parseFloat(paidCount.length) / parseFloat(this.state.globalGroupMembers.length)) * 100
        this.setState({ notPaidmembersCount: notPaidCount, paidPercentage: percentage })
        //--------------- Sort array ------------------//
        for (let a = 0; a < this.state.globalGroupMembers.length; a++) {
            let mpaidstatus = "";
            let pop = "";
            let paidStatusArray = {};

            mpaidstatus = this.getCasePayStatus(caseid, this.state.globalGroupMembers[a].id);
            pop = this.getCasePop(caseid, this.state.globalGroupMembers[a].id);

            paidStatusArray['memberid'] = this.state.globalGroupMembers[a].id;
            paidStatusArray['fullname'] = (this.state.globalGroupMembers[a].name).replace(/\s+$/, '') + ' ' + (this.state.globalGroupMembers[a].surname).replace(/\s+$/, '')
            paidStatusArray['paidstatus'] = mpaidstatus;
            paidStatusArray['pop'] = pop;
            sortedArray.push(paidStatusArray);
        }
        let sortedItems = sortedArray.sort((a, b) => b.paidstatus.localeCompare(a.paidstatus));
        this.setState({ sortedValues: sortedItems })

    }

    componentDidUpdate() {
        window.onpopstate = e => {
            if (window.confirm('Are you sure you want to log out?')) {
                this.appLogout();
            } else {
                this.props.navigate('/casereports', {
                    state: {
                        db: this.state.db, email: this.state.email,
                        firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
                    }
                });
            }
        }
    }

    // LOAD GROUP CASES------------
    loadGroupCases = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }
        }
        // const url = "http://localhost/kimvuka-php/api/getGroupCases.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupCases.php";
        const response = await axios.get(url, config);
        //console.log(response.data)
        if (Array.isArray(response.data)) {
            this.setState({ groupCases: response.data });
            response.data.map(key => {
                this.lGroupCases.push({
                    label: key.category + '_' + key.name, value: key.id
                });

            })

        }

        if (response.data === 'No data found') {
            this.setState({ casesCount: response.data })
        }

        //console.log(response.data)

    }
    //----GET ALL CASES STATUS
    getAllCaseStatuses = async (e) => {

        let config = {
            headers: { 'Accept': 'application/json' },
            params: {
                "businessname": this.props.location.state.db
            }
        }
        // const url = "http://localhost/kimvuka-php/api/getGroupCaseStatus.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupCaseStatus.php";
        const response = await axios.get(url, config);
        //console.log('All case status-------')
        // console.log(response.data);
        this.setState({ casesStatuses: response.data })

    }
    //-----LOAD GROUP ALL MEMBERS
    loadGroupAllMembers = async (e) => {

        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }

        }
        // const url = "http://localhost/kimvuka-php/api/getGroupAllmemberships.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupAllmemberships.php";
        const response = await axios.get(url, config);
        if (response.status === 200) {

            // this.allGroupMembersCount = response.data.length;
            // console.log('-----------'+this.allGroupMembersCount);
            this.setState({ globalGroupMembers: response.data });
        }
    }
    // 
    getCaseDetails = (caseid) => {
        for (let i = 0; i < this.state.groupCases.length; i++) {
            if (caseid === this.state.groupCases[i].id) {
                this.casecategory = this.state.groupCases[i].caseoption
                this.casestartdate = this.state.groupCases[i].startdate
                this.caseamount = 'R' + parseFloat(this.state.groupCases[i].amount).toFixed(2)
                break
            }
        }
    }
    // Set case change
    setCaseChange = (caseid, casename) => {
        this.getAllCaseStatuses();
        // this.loadGroupAllMembers();
        this.lCaseId = caseid;
        this.getCaseDetails(caseid);
        this.getGroupCaseStats(caseid);

        this.setState({
            caseid: caseid, casename: casename, groupMembers: this.state.globalGroupMembers
        });
        document.getElementById("clearDiv").style.display = "block";
        document.getElementById("caseStat").style.display = "block";
    }
    // Clear Report
    ClearReport = () => {
        this.lCaseId = 0;
        this.setState({ groupMembers: [], casename: "", sortedValues:[] })
        this.caseamount = "";
        this.casecategory = "";
        this.casestartdate = "";
        document.getElementById("clearDiv").style.display = "none";
        document.getElementById("caseStat").style.display = "none";
    }
    appLogout = (e) => {
        // e.preventDefault();
        this.props.navigate('/', { replace: true, state: { db: '', email: '', firstname: '' } });
    }
    goToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                db: this.props.location.state.db, email: this.props.location.state.email,
                firstname: this.props.location.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }
    getCasePayStatus = (caseid_, memberId) => {
        let payStatus = 'Not paid';
        let paidCount = [];
        let notPaidCount = [];

        //  this.paidCount = 0;
        // this.notPaidCount = 0;
        //console.log(this.state.casesStatuses);
        for (let i = 0; i < this.state.casesStatuses.length; i++) {

            if ((caseid_ === this.state.casesStatuses[i].caseid) && (memberId === this.state.casesStatuses[i].memberid)) {
                payStatus = this.state.casesStatuses[i].status
                break;
            }
        }
        return payStatus;
    }
    getCasePop = (caseid_, memberId) => {
        let pop = '';
        //console.log(this.state.casesStatuses);
        for (let i = 0; i < this.state.casesStatuses.length; i++) {

            if ((caseid_ === this.state.casesStatuses[i].caseid) && (memberId === this.state.casesStatuses[i].memberid)) {
                pop = this.state.casesStatuses[i].url
                break;
            }
        }
        return pop
    }

    render() {
        return (
            <div id="MycasesDiv" className='mainDivHome' style={{ border: '2px solid rgb(89, 100, 95)', borderRadius: "10px" }}>
                <div style={{ width: "100%" }}>
                    <span>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "white", fontStyle: "italic" }} onClick={this.goToMenu}>Main Menu</Button>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "#ff7400", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                    </span>
                </div>
                <div style={{ paddingTop: "10px", textAlign: "center" }}>
                    <span style={{ fontStyle: "italic" }} className="businessname"><h4>{this.props.location.state.db}</h4></span>
                    <span style={{ fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                    <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>
                </div>
                <div>
                    <div style={{ textAlign: "center", paddingTop: "5px" }}><Label> <h4>CASE REPORTS</h4></Label></div>
                </div>
                <div>
                    <FormGroup>
                        <Label for='mycases'>Select case</Label>
                        <Select
                            options={this.lGroupCases}
                            maxMenuHeight="100%"
                            // defaultInputValue={this.props.memberGender}
                            onChange={opt => this.setCaseChange(opt.value, opt.label)}
                        // value={this.props.memberGender}
                        //  key={this.props.memberGender}
                        ></Select>
                    </FormGroup>
                </div>

                <div style={{ paddingBottom: "10px" }}>
                    <div style={{ width: "100%", display: "none" }} id="caseStat">
                        <div style={{ width: "55%", float: "left" }}>
                            <label for='casename'><b>{this.state.casename}</b></label><br />
                            <label for='casecategory'><b>{this.casecategory}</b></label><br />
                            <label for='casestart'><b>{this.casestartdate}</b></label><br />
                            <label for='caseamount'><b>{`${this.caseamount}`}</b></label>
                        </div>
                        <div style={{ width: "45%", float: "right" }}>
                            <label for='membercount'><b>Member count</b> </label><span style={{ float: "right", paddingRight: "5px", color: "red" }}><b>{this.state.globalGroupMembers.length}</b></span><br />
                            <label for='paidmembercount'><b>Paid count</b> </label><span style={{ float: "right", paddingRight: "5px", color: "red" }}><b>{this.state.paidmembersCount}</b></span><br />
                            <label for='nonpaidcount'><b>Not paid count</b></label><span style={{ float: "right", paddingRight: "5px", color: "red" }}><b>{this.state.notPaidmembersCount}</b></span><br />
                            <label for='paidpercentage'><b>Participation </b></label><span style={{ float: "right", paddingRight: "5px", color: "red" }}><b>{Number(this.state.paidPercentage).toFixed(0)}%</b></span>
                        </div>
                        <FormGroup>
                            <Label for='mycases' style={{ width: "100%", textAlign: "center" }}></Label>
                        </FormGroup>
                    </div>
                    <div>
                        <table style={{ borderBottom: "1px solid white", width: "100%", fontSize: "15px" }}><thead>
                            <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>No</th>
                            <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Full name</th>
                            <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Status</th>
                            <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>POP</th>
                        </thead><tbody>

                                {
                                    this.state.sortedValues.map((item, index) => {
                                        {
                                            (() => {

                                                // if ((this.getCasePop(this.lCaseId, item.id) !== "") && (this.getCasePop(this.lCaseId, item.id) !== null)) {
                                                if (item.pop !== '') {
                                                    // this.strImage = this.getCasePop(this.lCaseId, item.id)
                                                    this.strTag = <a href={'../files/' + item.pop} target='_balnk'>View</a>
                                                }
                                                if (item.paidstatus === 'Paid') {
                                                    this.str_ = "bold"
                                                    this.strcolor = ''
                                                }
                                                else{this.strcolor = 'underline'}
                                            }

                                            )()
                                        }
                                        return (<tr style={{ textDecoration:`${this.strcolor}`, height: "5px", color:'darkblue', fontWeight: `${this.str_}`, borderBottom: "1px solid white", borderTop: "1px solid white", cursor: "pointer" }}
                                            key={item.id}>
                                            <td style={{  borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>{index + 1}</td>
                                            <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>{item.fullname}</td>
                                            <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>{item.paidstatus}</td>
                                            <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>
                                                {this.strTag}</td>
                                            {this.strTag = ""}
                                            {this.str_ = ""}
                                            {this.strcolor = ""}
                                        </tr>)
                                    }

                                    )}
                            </tbody>
                        </table>
                    </div>

                    <div id="clearDiv" style={{ alignItems: "center", paddingTop: "20px", float: "center", display: "none" }}>
                        <Button style={{ width: "100%", fontWeight: "bold" }}
                            onClick={this.ClearReport}>
                            Clear
                        </Button>
                    </div>

                </div>
            </div>)
    };

}
export default withNavigateHook(Casereports)